import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router';
import moment from 'moment';
import { toastsActions } from '@zola-helpers/client';

import { RenderField, RenderDatePicker, RenderSubmitButton } from '../../../common/form';
import * as Validations from '../../../common/form/commonValidations';
import { updateWeddingAccount, updateWedding } from '../../../../actions/WeddingActions';

class WeddingInfoForm extends React.Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
    this.routerWillLeave = this.routerWillLeave.bind(this);
    this.state = {
      successfulSave: false,
    };
  }

  componentDidUpdate() {
    const { dirty } = this.props;
    if (dirty) {
      this.props.router.setRouteLeaveHook(
        this.props.routes[this.props.routes.length - 1],
        this.routerWillLeave
      );
    }
  }

  onSubmit(values) {
    const { handleSubmit } = this.props;
    const submitReturn = handleSubmit(values);
    submitReturn.then(this.handleSuccess);
  }

  handleSuccess() {
    // TODO: factor this out out somewhere
    this.setState({ successfulSave: true });
    setTimeout(() => this.setState({ successfulSave: false }), 1000);
  }

  routerWillLeave() {
    const { dirty } = this.props;
    if (dirty)
      return 'You have unsaved changes. Hit "Cancel" to save them or risk losing your work.';
    return undefined;
  }

  render() {
    const { pristine, valid } = this.props;
    const { successfulSave } = this.state;
    return (
      <div>
        <form onSubmit={this.onSubmit} noValidate>
          <Field
            name="wedding.title"
            id="wedding-info-title"
            label="Title"
            type="text"
            component={RenderField}
            maxChars={50}
            required
            validate={[Validations.REQUIRED, Validations.MAX_LENGTH_50]}
          />
          <Field
            name="date"
            id="wedding-info-date"
            label="Date"
            component={RenderDatePicker}
            validate={[
              Validations.REQUIRED,
              Validations.DATE,
              Validations.CHECK_CURRENT_WEDDING_DATE,
              Validations.DATE_WITHIN_VALID_RANGE,
            ]}
            required
          />
          <div className="city-state">
            <div className="col-xs-6">
              <Field
                name="account.city"
                id="wedding-city"
                label="City"
                component={RenderField}
                type="text"
              />
            </div>
            <div className="col-xs-6">
              <Field
                name="account.state_province"
                id="wedding-state"
                label="State / Province"
                component={RenderField}
                type="text"
              />
            </div>
          </div>
          <Field
            name="wedding.hashtag"
            id="wedding-info-hashtag"
            label="Hashtag"
            type="text"
            inputGroup="#"
            placeholder="AnythingForLove"
            component={RenderField}
            maxChars={40}
            validate={Validations.MAX_LENGTH_40}
          />
          <RenderSubmitButton
            pristine={pristine}
            disableWhenPristine
            className="btn-wide"
            showSuccess={successfulSave}
            valid={valid}
          />
        </form>
      </div>
    );
  }
}

WeddingInfoForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  dirty: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  router: PropTypes.shape({
    setRouteLeaveHook: PropTypes.func,
  }),
};

const formatDateForEdit = form => {
  if (form.wedding.wedding_date) {
    return moment.utc(form.wedding.wedding_date).format('MM/DD/YYYY');
  }
  return undefined;
};

const mapStateToProps = state => ({
  initialValues: Object.assign({}, state.wedding, {
    date: formatDateForEdit(state.wedding),
    currentlySelectedDate: state.wedding.wedding.wedding_date,
    registryIsPublic: state.registry.public,
  }),
});

const mapDispatchToProps = dispatch => ({
  onSubmit: weddingInfoRequest => {
    const request = Object.assign({}, weddingInfoRequest);
    if (weddingInfoRequest.date) {
      request.wedding.event_date = moment.utc(weddingInfoRequest.date);
      request.wedding.wedding_date = moment.utc(weddingInfoRequest.date).format('YYYY-MM-DD');
    }
    return dispatch(updateWedding(request.wedding)).then(() => {
      dispatch(updateWeddingAccount(request.account)).then(() =>
        dispatch(toastsActions.positive({ headline: 'Wedding Summary Updated' }))
      );
    });
  },
});

let WeddingFormWithRouter = withRouter(WeddingInfoForm);
WeddingFormWithRouter = reduxForm({
  form: 'weddingInfoForm',
  enableReinitialize: true,
})(WeddingFormWithRouter);

export default connect(mapStateToProps, mapDispatchToProps)(WeddingFormWithRouter);
